import { CloseRounded, InfoOutlined } from '@material-ui/icons'
import React from 'react'

import './locationPopup.css'

const LocationPopup = ({isVisible, setIsVisible}) => {

  return isVisible && (
    <div className="locationPopup">
      <div className="locationPopupWrapper">
        <div className="popupTop">
          <button className="closeBtn" onClick={() => setIsVisible(false)}><CloseRounded /></button>
        </div>
        <div className="popupMiddle">
          <div class="alert alert-warning w-100" role="alert">
            <InfoOutlined style={{ marginRight: '.2rem', fontSize: '1.1rem' }} /> Warning: This popup is just a placeholder, I'm still working on it ...
          </div>
          <input type="text" className="locationInput" placeholder='Search a location'/>
        </div>
        <div className="popupBottom">
          <button className="locationCancelBtn" onClick={() => setIsVisible(false)}>Cancel</button>
          <button className="locationSubmitBtn">Submit</button>
        </div>
      </div>
    </div>
  )
}

export default LocationPopup